/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { FuturesContractsResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class RefFuturesContracts<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name GetFuturesContracts
   * @request GET:/refFuturesContracts
   * @secure
   */
  getFuturesContracts = (params: RequestParams = {}) =>
    this.request<FuturesContractsResponse, any>({
      path: `/refFuturesContracts`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsRefFuturesContracts
   * @request OPTIONS:/refFuturesContracts
   */
  optionsRefFuturesContracts = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/refFuturesContracts`,
      method: 'OPTIONS',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsRefFuturesContracts2
   * @request OPTIONS:/refFuturesContracts/{id}
   * @originalName optionsRefFuturesContracts
   * @duplicate
   */
  optionsRefFuturesContracts2 = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/refFuturesContracts/${id}`,
      method: 'OPTIONS',
      ...params,
    });
}
